import axios from "@/axios.js"

export default {
  searchRole({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.get("api/roles/search_role/" + item)
        .then((response) => {
          commit('SET_ROLES', response.data)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  searchAutocomplete({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.get("api/roles/search/" + item)
        .then((response) => {
          // // console.log(response)
          commit('SET_AUTOCOMPLETE_DATA', response.data.data)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  updateRole({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.post("/api/roles/update_role", {
          item: item
        })
        .then((response) => {
          // // console.log(response)
          commit('EDIT_ITEM', Object.assign(item, {
            id: response.data.id
          }))
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  addRole({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.post("/api/roles/add_roles", {
          item: item
        })
        .then((response) => {
          // // console.log(response)
          commit('ADD_ITEM', Object.assign(item, {
            id: response.data.id
          }))
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  updateRolePermission({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.post("/api/roles/update_role_permission", {
          item: item
        })
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  fetchAllRoles({
    commit
  },item) {
    return new Promise((resolve, reject) => {
      axios.get("/api/roles/" + item.page_no + "/" + item.per_page)
        .then((response) => {
          commit('SET_ROLES', response.data)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  fetchAllRolesWithFilter({
    commit
  },item) {
    return new Promise((resolve, reject) => {
      axios.post("/api/roles/roles_with_filter", {
          item: item
        })
        .then((response) => {
          commit('SET_ROLES', response.data)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  fetchRoles({
    commit
  }) {
    return new Promise((resolve, reject) => {
      axios.get("/api/roles/all_roles")
        .then((response) => {
          commit('SET_ROLES', response.data)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  fetchRole(context, roleId) {
    return new Promise((resolve, reject) => {
      axios.get(`/api/roles/${roleId}`)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
    fetchRoleList({
      commit
    },item) {
    return new Promise((resolve, reject) => {
      axios.get(`/api/roles/${item}`)
        .then((response) => {
          commit('SELECTED_ROLE', response.data)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  removeRole({
    commit
  }, roleId) {
    return new Promise((resolve, reject) => {
      // alert(roleId)
      axios.delete(`/api/roles/${roleId}`)
        .then((response) => {
          commit('REMOVE_ROLE', roleId)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  }
}
